function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M213.116,60.953h-20.995c-7.488-28.337-33.337-49.293-63.995-49.293S71.619,32.616,64.131,60.953H43.136 c-4.156,0-7.537,3.381-7.537,7.537v169.98c0,4.156,3.381,7.537,7.537,7.537h169.98c4.156,0,7.537-3.381,7.537-7.537V68.49 C220.653,64.334,217.272,60.953,213.116,60.953z M128.126,22.66c24.538,0,45.379,16.103,52.533,38.293H75.593 C82.747,38.763,103.587,22.66,128.126,22.66z M209.599,234.953H46.653V72.008H62.21c-0.169,1.926-0.272,3.871-0.272,5.841v21.893 c0,3.038,2.462,5.5,5.5,5.5s5.5-2.462,5.5-5.5V77.849c0-1.973,0.109-3.921,0.312-5.841h109.754c0.203,1.92,0.312,3.868,0.312,5.841 v21.893c0,3.038,2.463,5.5,5.5,5.5s5.5-2.462,5.5-5.5V77.849c0-1.97-0.104-3.915-0.272-5.841h15.557V234.953z"
});

function SvgIconShop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShop);
export default __webpack_public_path__ + "static/media/icon-shop.b73c19ac63edf154796f42e4b981d728.svg";
export { ForwardRef as ReactComponent };